import { Routes } from '@angular/router';
import { bookingResolver } from './booking/data-access/booking.resolver';

export const routes: Routes = [
  {
    path: 'book/:invitationId',
    loadComponent: () => import('./booking/feature/booking').then(m => m.BookingComponent),
    resolve: { booking: bookingResolver },
  },
  {
    path: 'book/:invitationId/confirmation',
    loadComponent: () => import('./booking/feature/booking-confirmation').then(m => m.BookingConfirmationComponent),
  },
  {
    path: 'book/:invitationId/completed',
    loadComponent: () => import('./booking/feature/booking-completed').then(m => m.BookingCompletedComponent),
  },
  {
    path: 'book/:invitationId/expired',
    loadComponent: () => import('./booking/feature/booking-expired').then(m => m.BookingExpiredComponent),
  },
  { path: 'invalid', loadComponent: () => import('./booking/feature/booking-not-found').then(m => m.BookingNotFoundComponent) },
  { path: '**', loadComponent: () => import('./booking/feature/booking-not-found').then(m => m.BookingNotFoundComponent) },
];
